// extracted by mini-css-extract-plugin
export var main = "index-module--main--prlSm";
export var container = "index-module--container--y+7M-";
export var card = "index-module--card--eNqzz";